<template lang="pug">
  div.page--payment.page
    checkout-page-header.page-header--account(
      :step="2"
      header-class="page-header--checkout-step"
      header-background="/img/frontend/page/page-header-default-background.jpg"
    )
    .container.mt-5
      .row
        .col-lg-7
          .checkout-shipping
            h3.checkout-shipping__title {{ trans('labels.frontend.payment.select_payment_method') }}
            .form-group
              .custom-radio.custom-radio--payment
                input#wire-transfer-method(type='radio', name='payment-method', value='wire_transfer', v-model="payment_method")
                .custom-radio__content
                  label.custom-radio__label(for='wire-transfer-method')
                    .custom-radio__image.w-100.align-items-center
                      img(src="/img/frontend/icons/wire-transfer.svg", alt='')
                      span.custom-radio__title {{ trans('labels.frontend.payment.bank_transfer') }}
            .alert-notification.alert-notification--warning.mb-3(v-if="$store.getters['cart/net_total'] < 1000")
              | {{ trans('labels.frontend.payment.minimum_order_for_cc') }}
            .form-group
              .custom-radio.custom-radio--payment
                input#credit-card-method(type='radio', name='payment-method', value='credit_card', v-model="payment_method")
                .custom-radio__content.custom-radio__content--cc
                  label.custom-radio__label.flex-column.custom-radio__label--cc(for='credit-card-method')
                    .custom-radio__image
                      img(src="/img/frontend/icons/credit-card.svg", alt='')
                      span.custom-radio__title {{ trans('labels.frontend.payment.credit_card_method') }}
                    p {{ trans('labels.frontend.payment.pay_securely_with_ssl') }}
                    div
                      .card-form
                        .field-group
                          label.control-label {{ trans('labels.frontend.payment.name_on_card') }}
                          #card-name.field
                      .card-form
                        .field-group
                          label.control-label {{ trans('labels.frontend.payment.card_number') }}
                          #card-number.field
                      .card-form
                        .field-group
                          label.control-label {{ trans('labels.frontend.payment.expiration') }}
                          #card-expiry.field
                      .card-form
                        .field-group
                          label.control-label {{ trans('labels.frontend.payment.ccv') }}
                          #card-cvv.field
                    p
                      img(src="/img/frontend/logo/payment/verified-by-visa.svg", alt='')
                      img(src="/img/frontend/logo/payment/mastercard.svg", alt='')


        .col-lg-4.offset-lg-1
          .cart-summary
            .cart-summary__body
              table.table.cart-summary__table
                tbody
                  tr
                    td {{ trans('labels.frontend.cart.table.sub_total_vat_incl') }}
                    td.text-right ฿ {{ $store.getters['cart/totals'] | numeral }}
                  tr(v-if="$store.getters['cart/coupon'] && $store.getters['cart/coupon'].id")
                    td {{ trans('labels.frontend.cart.table.discount') }} ({{ $store.getters['cart/coupon'].code }})
                    td.text-right
                      strong.text-primary - ฿ {{ $store.getters['cart/total_discount'] | numeral }}
                  tr
                    td {{ trans('labels.frontend.cart.table.shipping_fees') }}
                    td.text-right ฿ {{ $store.getters['cart/shipping_cost'] | numeral }}
                  tr
                    td
                      strong {{ trans('labels.frontend.cart.table.net_total') }}
                    td.text-right ฿ {{ $store.getters['cart/net_total'] | numeral }}
            .cart-summary__body
              button.btn.btn-primary.btn-block.btn-lg(:disabled="loading.isPlacingOrder" v-if="loading.isPlacingOrder")
                font-awesome-icon(:icon="['far', 'circle-notch']" spin).mr-2
                | {{ trans('labels.frontend.payment.proceeding') }}
              button.btn.btn-primary.btn-block.btn-lg(@click="onPlaceOrder" :disabled="loading.isPlacingOrder" v-if="!loading.isPlacingOrder")
                | {{ trans('labels.frontend.payment.proceed') }}
</template>

<script>
import CheckoutPageHeader from '../../../components/layouts/CheckoutPageHeader.vue';
import { RepositoryFactory } from '../../../repositoryFactory';
import notify from '../../../components/notify';
// eslint-disable-next-line import/no-cycle
import router from '../../../routes';

const OrderRepository = RepositoryFactory.get('order');

export default {
  components: {
    CheckoutPageHeader,
  },
  metaInfo() {
    return {
      title: Lang.get('labels.frontend.cart.steps.payment'),
    };
  },
  data() {
    return {
      cart: {},
      loading: {
        isPlacingOrder: false,
      },
      payment_method: 'wire_transfer',
      order: {},
    };
  },
  mounted() {
    const kbankScript = document.createElement('script');
    kbankScript.setAttribute('src', 'https://kpaymentgateway.kasikornbank.com/ui/v2/kinlinepayment.min.js');
    kbankScript.setAttribute('data-apikey', 'pkey_prod_4368bvZcS64bStdKU081GguruHJg3BE2eLH');
    kbankScript.setAttribute('data-lang', Lang.getLocale() || 'th');
    document.body.appendChild(kbankScript);

    kbankScript.onload = () => {
      this.initKbank();
    };

    this.$watch('payment_method', (val, oldVal) => {
      if (val === oldVal) return;
      if (val === 'credit_card') {
        console.log('this is cc method');
        this.initKbank();
      }
    });

    this.getCart();

    this.$ga.ecommerce.setAction('checkout', {
      step: 3,
    });
  },
  methods: {
    async getCart() {
      try {
        const { data } = await this.$store.dispatch('cart/get', { id: this.$store.getters['cart/id'] });
        this.cart = data;
        // this.initKbank();
      } catch (e) {
        this.cart = {};
      }
    },
    async onPlaceOrder() {
      this.loading = { ...this.loading, ...{ isPlacingOrder: true } };
      try {
        const { data } = await OrderRepository.store({
          cart_id: this.$store.getters['cart/id'],
          payment_method: this.payment_method,
        });

        if (this.payment_method === 'wire_transfer') {
          router.replace(`/thank-you?order=${data.number}`);
        } else if (this.payment_method === 'credit_card') {
          this.order = data;
          try {
            window.KInlineCheckout.getToken().then(
              async (result) => {
                console.log(result);
                await axios.post('/payment/gateway/kasikorn/cc-charge', {
                  order_id: this.order.id,
                  order_number: this.order.number,
                  user_id: this.order.user_id,
                  amount: this.order.net_total,
                  token: result.token,
                }).then((resp) => {
                  const chargeData = resp.data;
                  if (chargeData.transaction_state === 'Pre-Authorized') {
                    window.location.href = chargeData.redirect_url;
                  } else if (chargeData.transaction_state === 'Authorized') {
                    router.replace(`/thank-you?order=${chargeData.reference_order}`);
                  }
                });
              }
            ).catch(
              (error) => {
                this.loading = { ...this.loading, ...{ isPlacingOrder: false } };
                console.log(error);
              }
            );
          } catch (e) {
            this.loading = { ...this.loading, ...{ isPlacingOrder: false } };
            notify.errors(this, e);
          }
        }
      } catch (e) {
        this.loading = { ...this.loading, ...{ isPlacingOrder: false } };
        notify.errors(this, e);
      }
    },
    async initKbank() {
      // eslint-disable-next-line no-undef
      const kbankApi = KInlineCheckout;
      kbankApi.init();

      kbankApi.onInputValidation((elementName, result) => {
        console.log(elementName, result);
        const element = document.getElementById(elementName);

        if (result === 'valid') {
          element.classList.remove('is-invalid');
        } else {
          element.classList.add('is-invalid');
        }
      });

      kbankApi.onGetTokenFailed((text) => {
        console.log(text);
        document.getElementById('error-summary').click().add('show');
      });
    },
  },
};
</script>
